import { createSelector } from 'reselect'

import { filterKeyObjectives } from '../../lib'

import { selectStrategicInitiativesKeyObjectives } from './selectStrategicInitiativesKeyObjectives'
import { selectStrategicInitiativesSelectedFYear } from './selectStrategicInitiativesSelectedFYear'
import { selectStrategicInitiativesSelectedRtm } from './selectStrategicInitiativesSelectedRtm'

export const selectFilteredKeyObjectives = createSelector(
  [
    selectStrategicInitiativesKeyObjectives,
    selectStrategicInitiativesSelectedFYear,
    selectStrategicInitiativesSelectedRtm,
  ],
  filterKeyObjectives
)
